import { Loader, Flex } from "@mantine/core";

export function LoadingAnimation() {
    return (
        <Flex align="center" justify="center" w="100%">
            <Loader size="lg" />
        </Flex>
    );
}
